// CustomPage.jsx
import React, { useEffect, useState } from "react";
import AskList from "./Asks";

export default function CustomPage({ data }) {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState(null);
  const [authed, setAuthed] = useState(false);

  // 새로고침해도 유지하고 싶으면 sessionStorage 사용
  useEffect(() => {
    const saved = sessionStorage.getItem("asklist_authed");
    if (saved === "1") setAuthed(true);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id === "geostory" && pw === "geostory1004!!") {
      setAuthed(true);
      setError(null);
      sessionStorage.setItem("asklist_authed", "1");
    } else {
      setError("아이디 또는 비밀번호가 올바르지 않습니다.");
      setAuthed(false);
      sessionStorage.removeItem("asklist_authed");
    }
  };

  const handleLogout = () => {
    setAuthed(false);
    setId("");
    setPw("");
    sessionStorage.removeItem("asklist_authed");
  };

  if (!authed) {
    return (
      <div className="container" style={{ maxWidth: 420, paddingTop: 40 }}>
        <h3 className="mb-3">접속 필요</h3>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="login-id" className="form-label">
              아이디
            </label>
            <input
              id="login-id"
              type="text"
              className="form-control"
              placeholder="아이디를 입력하세요 (test)"
              value={id}
              onChange={(e) => setId(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="login-pw" className="form-label">
              비밀번호
            </label>
            <input
              id="login-pw"
              type="password"
              className="form-control"
              placeholder="비밀번호를 입력하세요 (1234)"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" style={{ marginTop: 12, float:  "inline-end" }}>
            로그인
          </button>
        </form>
      </div>
    );
  }

  // 로그인 성공 시 AskList 표시 + 로그아웃 버튼
  return (
    <div className="container" style={{ paddingTop: 24 }}>
      <div className="d-flex justify-content-end mb-2">
        <button className="btn btn-outline-secondary btn-sm" style={{ marginRight: -13, float:  "inline-end" }} onClick={handleLogout}>
          로그아웃
        </button>
      </div>
      <AskList />
    </div>
  );
}
